import { render, staticRenderFns } from "./ReactionToaster.vue?vue&type=template&id=245746c4&scoped=true"
import script from "./ReactionToaster.vue?vue&type=script&lang=js"
export * from "./ReactionToaster.vue?vue&type=script&lang=js"
import style0 from "./ReactionToaster.vue?vue&type=style&index=0&id=245746c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "245746c4",
  null
  
)

export default component.exports